import * as React from 'react'
import * as O from 'fp-ts/lib/Option'

import {
  Input,
  InputProps
} from '@espoon-voltti/react-components/elements/form'

import { parse } from './parse'

const defaultMax = 99999

interface Props extends Omit<InputProps, 'onChange' | 'value'> {
  onChange: (value: number | null) => void
  value: number | null
  max?: number
}

const parseValue = (value: number | null) => (value === null ? '' : `${value}`)

export const IntegerInput = (p: Props) => {
  const { value, onChange, ...inputProps } = p
  const [state, setState] = React.useState(parseValue(value))

  // format value on blur, this removes the preceding zeroes
  // also, it adds trailing zeroes, when required
  const handleBlur = (e: any) => {
    setState(parseValue(value))
    if (p.onBlur) {
      p.onBlur(e)
    }
  }

  // select input value when starting to type
  // ..for example there is a zero present, this will prevent preceding zeroes from being
  // inputted unintentionally
  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    e.target.select()

    if (p.onFocus) {
      p.onFocus(e)
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const candidate = e.target.value.trim()

    if (candidate === '') {
      setState(candidate)
      p.onChange(null)
      return
    }

    const maybeInt = parse(candidate)
    const max = p.max || defaultMax
    if (O.isSome(maybeInt) && maybeInt.value <= max) {
      setState(candidate)
      p.onChange(maybeInt.value)
    }

    // any other inputs are rejected
  }

  React.useEffect(() => {
    setState(parseValue(value))
  }, [value])

  return (
    <Input
      {...inputProps}
      type="text"
      value={state}
      onBlur={handleBlur}
      onFocus={handleFocus}
      onChange={handleChange}
    />
  )
}
